import React from "react";
import { Link } from "react-router-dom";
import "./item_table.scss";

const titles = [
    "Code",
    "Name",
];

const ActivityCostPakagesTable = ({ items, className }) => {
    const rows =
        items &&
        Object.values(items).map((item, index) => {
            return (
                <tr key={`item_value_${index}`} style={{ textAlign: "center" }}>
                    <td>
                        <Link to={`/costpackage/detail/${item.id}/`}>{item.code}</Link>
                    </td>
                    <td>{item.name}</td>
                </tr>
            );
        });

    return (
        <div {...{ className }}>
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`item_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
        </div>
    );
};

ActivityCostPakagesTable.header = (
    <nav className="navbar">
        <span className="navbar-brand h4">Related Cost Packages</span>
    </nav>
);

export default ActivityCostPakagesTable;
